/**
 * <s-email-popup data-open-now="true|">
 * Opens its <dialog> once per visitor: after 8 seconds or 40% scroll, whichever comes first.
 * Opens straight away after a signup so the visitor sees the thank-you or the error.
 */
const STORAGE_KEY = 'radalyn-email-popup-seen';

class EmailPopup extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    this.addEventListener('click', this.#onClick);
    this.dialog.addEventListener('close', this.#remember);

    if (this.dataset.openNow === 'true') {
      this.#open();
      return;
    }
    if (this.#seen()) return;
    this.#timer = window.setTimeout(() => this.#open(), 8000);
    window.addEventListener('scroll', this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.clearTimeout(this.#timer);
    window.removeEventListener('scroll', this.#onScroll);
    this.removeEventListener('click', this.#onClick);
  }

  #seen() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }

  #remember = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* storage unavailable: popup may show again next visit */
    }
  };

  #onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable > 0.4) this.#open();
  };

  #open() {
    window.clearTimeout(this.#timer);
    window.removeEventListener('scroll', this.#onScroll);
    if (this.dialog.open || document.querySelector('dialog[open]')) return;
    this.dialog.showModal();
  }

  #onClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('[data-close]') || target === this.dialog) this.dialog.close();
  };
}

if (!customElements.get('s-email-popup')) customElements.define('s-email-popup', EmailPopup);
